module.exports = __webpack_public_path__ + "default-author-image-4e82edd7e20425a9ff0f.svg";